/**
 * Porteiro das leituras do decodificador.
 *
 * O `html5-qrcode` decodifica a ~10fps e chama o callback A CADA QUADRO em que
 * o QR estiver visível. O `throttleTime(500)` que já existia só espaça as
 * emissões: um ingresso parado na frente da lente por dois segundos vira
 * quatro `scanSuccess` — e quatro POSTs de check-in, dos quais o servidor
 * aceita o primeiro e devolve 409 CHECKIN_JA_REALIZADO nos outros. O operador
 * lia UM ingresso e a tela dizia "ingresso já utilizado".
 *
 * `distinctUntilChanged` não resolve: ele bloqueia o mesmo código PARA SEMPRE,
 * e reler o mesmo ingresso de propósito (conferência na porta, entrada e saída)
 * é caso real.
 *
 * A regra certa é janela por código: o mesmo valor só volta a valer depois de
 * `cooldownMs`. Código diferente passa na hora — a fila não espera.
 */

export interface UltimaLeitura {
  codigo: string;
  /** `Date.now()` da emissão. */
  em: number;
}

export const COOLDOWN_PADRAO_MS = 2500;

export function deveEmitir(
  codigo: string,
  ultima: UltimaLeitura | null,
  agora: number,
  cooldownMs = COOLDOWN_PADRAO_MS,
): boolean {
  if (!ultima || ultima.codigo !== codigo) return true;
  return agora - ultima.em >= cooldownMs;
}
